import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteProgramCountryLead: (
  fetchContext: FetchContext,
  programCountryLeadId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, programCountryLeadId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/program-country-leads/${programCountryLeadId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete program country lead'));
